import { useState } from 'react';
import { RadioGroup, Radio } from '@nextui-org/react';

type Option = {
  value: string;
  label: string;
};

type SelectableRadioGroupProps = {
  options: Option[];
  value: string;
  label: string;
  onChange?: (value: string) => void;
};

export default function SelectableRadioGroup({ options, value, label, onChange }: SelectableRadioGroupProps) {
  const [selectedValue, setSelectedValue] = useState<string>(value);

  const handleChange = (value: string) => {
    setSelectedValue(value);
    if (onChange) {
      onChange(value);
    }
  };
  return (
    <RadioGroup
      label={label}
      value={selectedValue}
      onValueChange={handleChange}
      classNames={{
        label: 'font-semibold',
      }}
    >
      {options.map(({ value, label }) => (
        <Radio key={value} value={value}
          classNames={{
            wrapper:
            'group-data-[selected=true]:border-6 group-data-[selected=true]:border-[#438BF7] group-data-[selected=true]:rounded-[16px]',
          }}>
          {label}
        </Radio>
      ))}
    </RadioGroup>
  );
}
